import { ClockCircleOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import useHttp from "../../hooks/useHttp";
import { getHSFormattedDateString } from "../utils/dateUtils";
const { Title, Text } = Typography;

export const AppsList = ({ apps, appProperties, isWebsiteLogin, showSignInWithAnotherEmail = true }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { fetchData } = useHttp();

  useEffect(() => {
    if (apps?.length > 0) {
      setIsModalOpen(true);
    }
  }, [apps]);

  const handleLogout = useCallback(() => {
    let appPropObj = { companyId: appProperties?.companyId, userId: appProperties?.userId, websiteLogin: isWebsiteLogin };
    fetchData(`website/logout`, "DELETE", null, appPropObj).then(function (response) {
      if (typeof response === "string") {
        response = JSON.parse(response);
      }
      if (response?.data?.isValid) {
        window.location.href = "/web/signin";
      }
    });
  }, [fetchData, appProperties, isWebsiteLogin]);

  const redirectToApp = useCallback(
    (app) => {
      let appPropObj = { companyId: appProperties?.companyId, userId: appProperties?.userId, websiteLogin: isWebsiteLogin };
      fetchData(
        `website/redirect/app?osyncId=${app.osyncId}&leftServiceId=${app.leftServiceId}&orgId=${app.orgId}&remoteUserId=${app.remoteUserId}&externalServiceName=${app.externalServiceName}&osyncUserId=${app.osyncUserId}`,
        "POST",
        null,
        appPropObj
      ).then(function (response) {
        console.log("response >>>>>>>>>>>>>>>>>>>>>", response);
        if (response) {
          response = JSON.parse(response);
          if (response?.data) {
            window.location.href = response?.data;
          }
        }
      });
    },
    [fetchData, appProperties?.controller, isWebsiteLogin]
  );

  return (
    <Modal
      open={isModalOpen}
      width={"40vw"} // or 1000, or even '80vw'
      centered
      title={
        <div className="d-flex justify-content-center align-items-center">
          <Row gutter={[16, 8]} align="middle">
            <Col span={24} className="d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-center align-items-center hs-fs-20 hs-fw-bold">Choose an account</div>
            </Col>
            <Col span={24} className="d-flex justify-content-center align-items-center">
              <div className="hs-color-light-grey-2 hs-fw-400 hs-fs-14">to continue to the application </div>
            </Col>
          </Row>
        </div>
      }
      footer={
        showSignInWithAnotherEmail && (
          <Row gutter={[16, 0]} align="middle" style={{ padding: "16px 12px" }}>
            <Col span={24} className="d-flex justify-content-center align-items-center pe-5 cursor-pointer">
              <div className="d-flex flex-row justify-content-center align-items-center" onClick={handleLogout}>
                <div className="hs-fs-14 hs-color-violet">Sign in with another email </div>
              </div>
            </Col>
          </Row>
        )
      }
      onCancel={() => setIsModalOpen(false)}
    >
      <div
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: 8,
          background: "#fff",
          overflow: "hidden",
        }}
      >
        {apps.map((app, idx) => (
          <div key={app.osyncId}>
            <Row
              gutter={[16, 0]}
              align="middle"
              style={{ padding: "16px 12px" }}
              className="settingsHover cursor-pointer"
              onClick={() => redirectToApp(app)}
            >
              <Col span={4}>
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div
                    className={`applicationLogosSprite ${app.appLogoName === "no-integration-logo" ? "hello-send-logo" : app.appLogoName}`}
                  ></div>
                </div>
              </Col>
              <Col span={20}>
                <Title level={5} style={{ margin: 0 }} className="hs-color-BlackRussian hs-fw-500 hs-fs-14">
                  {app.appName}
                </Title>
                <Text type="secondary" style={{ display: "block", marginTop: 4 }} className="hs-color-dark-grey hs-fw-400 hs-fs-12">
                  Organization: {app.orgId}
                </Text>
                {app?.installedBy ? (
                  <Text type="secondary" style={{ display: "block", marginTop: 4 }} className="hs-color-dark-grey hs-fw-400 hs-fs-12">
                    Installed by: {app.installedBy}
                  </Text>
                ) : null}
                <Text type="secondary" style={{ display: "block", marginTop: 2 }} className="hs-color-dark-grey hs-fw-400 hs-fs-12">
                  <ClockCircleOutlined className="hs-fs-14 hs-color-light-grey-2" style={{ marginRight: 4 }} />
                  Created: {getHSFormattedDateString(app.createdTime)}
                </Text>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </Modal>
  );
};
